import { createActionGroup, props } from '@ngrx/store';
import { MembershipEntity } from '../../../../entities/mdqx/doctor/membership.entity';
import { MutationChangeMembershipArgs, MutationDeleteMembershipArgs } from '../../../../mdqx-graphql-types';

export const MembershipActions = createActionGroup({
    source: 'membership',
    events: {
        'Load Success': props<{ Payload: MembershipEntity[] }>(),
        'Load Request': props<{ Payload?: {}/*todo*/ }>(),
        'Load Failure': props<{ Errors: any; ToasterMessage?: string }>(),

        // 'Put Request': props<{ Payload: {}/*todo*/ }>(),
        'Put Failure': props<{ Errors: any; ToasterMessage?: string }>(),
        'Put Success': props<{ Payload: MembershipEntity[] }>(),

        'Change Request': props<{ Payload: MutationChangeMembershipArgs }>(),
        'Change Failure': props<{ Errors: any; ToasterMessage?: string }>(),
        'Change Success': props<{ Payload: MembershipEntity }>(),

        'delete Request': props<{ Payload: MutationDeleteMembershipArgs }>(),
        'delete Failure': props<{ Errors: any; ToasterMessage?: string }>(),
        'delete Success': props<{ Payload: number }>(),
    },
});
